module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Create Coupon":"Gutschein erstellen","Save the coupon and close":"Gutschein speichern und schließen","Coupon could not be saved.":"Gutschein konnte nicht gespeichert werden.","Coupon has been created successfully!":"Gutschein wurde erfolgreich erstellt!","Could not print the coupon!":"Gutschein konnte nicht gedruckt werden!","Print":"Drucken"}}')
  delete Component.options._Ctor
}
